module.exports = __webpack_public_path__ + "static/media/sup_tropical_640.c303bcc6.webp";